import React, { ReactNode } from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import { BackArrowIcon } from './icons'

const Container = styled.div`
    align-items: center;
    display: flex;
    font-size: 17px;
    font-weight: bold;
    height: 36px;
    margin-bottom: 20px;
    width: 100%;
`

const BackButton = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    margin-right: auto;

    span {
        padding: 0 8px;
    }
`

type Props = {
    children?: ReactNode
}

const CreationToolNavigation = ({ children }: Props) => {
    const history = useHistory()

    const onBackClick = () => {
        history.goBack()
    }

    return (
        <Container>
            <BackButton onClick={onBackClick}>
                <BackArrowIcon />
                <span>Back</span>
            </BackButton>
            {children}
        </Container>
    )
}

export default CreationToolNavigation
